/* projects/signature-it/ngx-catalogue/components/catalog/products-cards/product-card/product-card.component.scss */
.card.card-item.list-card .card-body {
  margin-inline: 9rem;
}
.card.card-item.list-card .card-images .card-img-top {
  width: 5rem;
}
.card.card-item.grid-card .card-images .card-img-top {
  height: 152px;
  width: 9.5rem;
}
.card.card-item.grid-card .body-footer-container {
  margin-top: 0.75rem;
}
/*# sourceMappingURL=product-card.component.css.map */
